import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import {
  dateWithWordFilter,
  dateWithWordFullFilter
} from "./filters/date.filter";
import messagePlugin from "./utils/message.plugin";

import Vuelidate from "vuelidate";

Vue.filter("dateWithWordFilter", dateWithWordFilter);
Vue.filter("dateWithWordFullFilter", dateWithWordFullFilter);

Vue.config.productionTip = false;
Vue.use(messagePlugin);
Vue.use(Vuelidate);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
